/**
* Dropdown
* -----------------------------------------------------------------------------
* Exposes methods for opening and closing the dropdown.  All logic is handled externally
*
* @constructor
* @param {jQuery} $trigger - Element matching selectors.dropdownTrigger
*/

var selectors = {
    dropdownTrigger: 'data-dropdown-trigger'
};

var classes = {
    dropdownOpen: 'is-open'
};

function Dropdown($trigger) {
    this.$trigger = $trigger;
    this.$el = $("#" + this.$trigger.attr(selectors.dropdownTrigger));

};

Dropdown.prototype = {
    isOpen: function() {
        return this.$el.hasClass( classes.dropdownOpen );
    },
    open: function() {
        this.$el.addClass( classes.dropdownOpen );
    },
    close: function() {
        this.$el.removeClass( classes.dropdownOpen );
    }
}

module.exports = Dropdown;



//////////////////
// WEBPACK FOOTER
// ./navigation/js/dropdown.js
// module id = 143
// module chunks = 3